import React from 'react';
import useCounterAnimation from '../hooks/useCounterAnimation';

/**
 * AnimatedCounter
 * @param {number} end - The final value to count to
 * @param {number} duration - Duration of the animation in ms
 * @param {string} [suffix] - Optional suffix to display (e.g. %, +)
 */
const AnimatedCounter = ({ end, duration = 1500, suffix = '' }) => {
  const value = useCounterAnimation(end, duration);
  return (
    <>
      {value}
      {suffix}
    </>
  );
};

export default AnimatedCounter;
